import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Layout, Result } from 'antd';
import { cloudFunctions } from '../../config/Fire';
import LoadingPage from '../../components/LoadingPage';

const { Header, Content, Footer } = Layout;
const logo = require('./../../images/logo_reservando_word.png');

const Results = {
    DEFAULT_ERROR: "DEFAULT_ERROR",
    EXPIRED_ERROR: "EXPIRED_ERROR",
    SUCCESSFUL: "SUCCESSFUL",
}
class VerificationEmail extends Component {
    state = {
        loading: true,
        result: "",
    };

    componentDidMount() {
        const { location } = this.props;
        var paths = location.pathname.split("/");
        if(paths[2]) {
            cloudFunctions.verifyEmail({
                linkEncrypted: paths[2],
            })
            .then((response) => {
                if(response.data.code !== undefined && response.data.code === 0) {
                    if(response.data.result !== undefined && response.data.result === "successful") {
                        console.log("successful")
                        this.setState({ loading: false, result: Results.SUCCESSFUL });
                    } else {
                        console.log("expired")
                        this.setState({ loading: false, result: Results.EXPIRED_ERROR });
                    }
                } else {
                    console.log("error 1")
                    this.setState({ loading: false, result: Results.DEFAULT_ERROR });
                }
            })
            .catch(err => {
                console.log("error db")
                this.setState({ loading: false, result: Results.DEFAULT_ERROR });
            });
        } else {
            console.log("error link")
            this.setState({ loading: false, result: Results.DEFAULT_ERROR });
        }
    }
    
    renderResult = result => {
        switch (result) {
            case Results.SUCCESSFUL:
                return (
                    <Layout>
                        <Header style={{ background: '#fff', padding: 0, textAlign: 'center' }} >
                            <img alt="example" src={logo} style={{ display:"block", margin:"auto", maxHeight:"100%" }} />
                        </Header>
                        <Content style={{ margin: '0 16px', textAlign: 'center' }}>
                                <div style={{ margin: '16px 0', padding: 24, background: '#fff' }}>
                                    <Result
                                    status="success"
                                    title="¡Correo confirmado!"
                                    subTitle="Felicitaciones, el correo electrónico fue confirmado exitósamente. Ya puede ingresar a Reservando." />
                                </div>
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>
                            Copyright ©2019 Reservando
                        </Footer>
                    </Layout>
                )
            case Results.EXPIRED_ERROR:
                return (
                    <Layout>
                        <Header style={{ background: '#fff', padding: 0, textAlign: 'center' }} >
                            <img alt="example" src={logo} style={{ display:"block", margin:"auto", maxHeight:"100%" }} />
                        </Header>
                        <Content style={{ margin: '0 16px', textAlign: 'center' }}>
                                <div style={{ margin: '16px 0', padding: 24, background: '#fff' }}>
                                    <Result
                                    status="warning"
                                    title="Link caducado."
                                    subTitle="Por favor, vuelva a solicitar la confirmacion de correo electrónico." />
                                </div>
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>
                            Copyright ©2019 Reservando
                        </Footer>
                    </Layout>
                )
            case Results.DEFAULT_ERROR:
                return (
                    <Layout>
                        <Header style={{ background: '#fff', padding: 0, textAlign: 'center' }} >
                            <img alt="example" src={logo} style={{ display:"block", margin:"auto", maxHeight:"100%" }} />
                        </Header>
                        <Content style={{ margin: '0 16px', textAlign: 'center' }}>
                                <div style={{ margin: '16px 0', padding: 24, background: '#fff' }}>
                                    <Result
                                    status="error"
                                    title="Se produjo un error."
                                    subTitle="Por favor, vuelva a solicitar la confirmacion de correo electrónico o intente nuevamente mas tarde." />
                                </div>
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>
                            Copyright ©2019 Reservando
                        </Footer>
                    </Layout>
                )
            default:
                return <h1>DEFAULT_ERROR</h1>
        }
    }

    render() {
        const { loading, result } = this.state;
        return (
            <div>
                {
                    loading ?
                        <LoadingPage />
                        :
                        this.renderResult(result)
                }
            </div>
        );
    }
}

export default withRouter(VerificationEmail);